<template>
  <ContainerSmall v-show="!loggedIn" class="min-h-screen">
    <img src="/images/Cardstock_Logo.png" class="block mx-auto mt-16 w-48 mb-4">
    <div v-if="!loggedIn">
      <div class="border rounded shadow-md bg-white px-4 py-4 mx-4 sm:mx-0">
        <div v-if="hasErrors" class="mb-2 p-4 rounded bg-red-700-700-20 text-gray-600">
          <div v-for="error in submitErrors">
            {{error}}
          </div>
        </div>
        <div class="mb-4">
          <label for="email" class="block text-gray-600 text-sm mb-2">
            Email
          </label>
          <input id="email" type="text" v-model="proposedEmail" class="appearance-none outline-none border border-gray-500 rounded w-full py-2 px-3 text-gray-600 focus:border-cardstock-green-500" tabindex="1" @keyup.enter="didSubmit">
        </div>
        <div class="mb-4">
          <label for="password" class="block text-gray-600 text-sm mb-2">
            Password
          </label>
          <input id="password" type="password" v-model="proposedPassword"  class="appearance-none outline-none border border-gray-500 rounded w-full py-2 px-3 text-gray-600 focus:border-cardstock-green-500" tabindex="2" @keyup.enter="didSubmit">
        </div>
        <ButtonSubmit :isSubmitting="isSubmitting" @click.native="didSubmit" class="w-full">
          Log in
        </ButtonSubmit>
      </div>
      <div class="mt-8 text-sm text-center">
        <strong>
          You can also:
        </strong>
        <router-link :to="{ name: 'passwordResetNew'}">
          Reset your password
        </router-link>
      </div>
    </div>
    <div v-else class="text-center">
      <div class="mb-4 text-3xl">
        Welcome back, {{currentUser.first}}!
      </div>
      <div>
        <router-link to="/teams">Continue</router-link> or <router-link to="/logout">Login as someone else</router-link>
      </div>
    </div>
  </ContainerSmall>
</template>

<script>
import Cookies        from 'js-cookie'

import { preload }  from '@/preloader'
import SocketLink     from '@/socketLink.js'
import {responseHandler, errorHandler} from '@/responseHandler'
import apolloProvider from '@/apolloProvider'
import gql from 'graphql-tag'

import CurrentUserQuery from '@/queries/CurrentUser.gql'

import ButtonSubmit   from '@/components/ButtonSubmit.vue'
import ContainerSmall from '@/components/ContainerSmall.vue'

export default {
  components: {
    ButtonSubmit,
    ContainerSmall
  },

  data: function () {
    return {
      loading: false,
      proposedEmail: '',
      proposedPassword: '',
      isSubmitting: false,
      hasErrors: false,
      submitErrors: [],
      currentUser: null,
      loggedIn: false
    }
  },

  beforeRouteEnter: (to, from, next) => {
    console.info(CurrentUserQuery)
    preload({
      query: CurrentUserQuery,
      queryName: 'currentUser',
      fetchPolicy: 'network-only',
      onSuccess: () => { next("/teams") },
      onError: () => { next() },
      callback: next
    })
  },

  beforeRouteUpdate: (to, from, next) => {
    preload({
      query: CurrentUserQuery,
      queryName: 'currentUser',
      fetchPolicy: 'network-only',
      onSuccess: ({data}) => { this.currentUser = data.currentUser; this.loggedIn = true },
      onError: () => { next() },
      callback: next
    })
  },

  computed: {
    redirect() {
      return this.$route.query.redirect || undefined
    }
  },

  methods: {
    didSubmit: function () {
      this.isSubmitting = true
      this.submitErrors = []
      this.hasErrors = false
      let emailToSend = this.proposedEmail
      let passwordToSend = this.proposedPassword
      this.proposedEmail = ''
      this.proposedPassword = ''

      this.$apollo.mutate({
        mutation: gql`mutation ($email: String!, $password: String!) {
          authentication(email: $email, password: $password) {
            token
            userId
          }
        }`,
        // Parameters
        variables: {
          email: emailToSend,
          password: passwordToSend
        },
        errorPolicy: 'all'
      })
      .then((resp) => {
        responseHandler({
          ...resp,
          component: "Login",
          query: "authentication mutation",
          onSuccess: (data) => {
            let teacherToken = data.authentication.token
            let userId = data.authentication.userId
            localStorage.setItem('cardstock_auth_token', teacherToken)
            SocketLink.reset()

            this.isSubmitting = false

            if(this.redirect !== undefined) {
              this.$router.push(this.redirect)
            } else {
              this.$router.push({name: 'teams'})
            }
          },
          onErrors: (formattedErrors) => {
            this.hasErrors = true
            this.isSubmitting = false
            this.proposedEmail = emailToSend
            this.submitErrors = formattedErrors
          }
        })
      })
      .catch((error) => {
        errorHandler({
          error: error,
          component: "Login",
          query: "authentication mutation",
          onError: (error) => {
            this.hasErrors = true
            this.isSubmitting = false
            this.proposedEmail = emailToSend
            this.submitErrors = [error]
          }
        })
      })
    }
  }
}
</script>
